import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const baseQuery = fetchBaseQuery({
    baseUrl: process.env.REACT_APP_WAF_API_URL,
    prepareHeaders: (headers) => {
        const user = localStorage.getItem('user');
        if (user) {
            try {
                const userToken = JSON.parse(user).token;
                headers.set('authorization', `Bearer ${userToken}`);
                headers.set('Content-Type', 'application/json');
            } catch (e) {
                console.error('Error parsing user token:', e);
            }
        }
        return headers;
    },
    credentials: "omit"
});

export const wafApi = createApi({
    reducerPath: "wafApi",
    baseQuery: baseQuery,
    tagTypes: ["CustomRule"],
    endpoints: (builder) => ({
        lookupIp: builder.query({
            query: (ip) => `lookup?ip=${encodeURIComponent(ip)}`
        }),
        getCustomRules: builder.query({
            query: () => `rules`,
            transformResponse: (response) => response.rules,
            providesTags: ["CustomRule"]
        }),
        addCustomRule: builder.mutation({
            query: (body) => ({
                url: `rules`,
                method: 'POST',
                body
            }),
            invalidatesTags: ["CustomRule"]
        }),
        deleteCustomRule: builder.mutation({
            query: (ip) => ({
                url: `rules?ip=${encodeURIComponent(ip)}`,
                method: 'DELETE'
            }),
            invalidatesTags: ["CustomRule"]
        })
    })
});

export const {
    useLazyLookupIpQuery,
    useGetCustomRulesQuery,
    useAddCustomRuleMutation,
    useDeleteCustomRuleMutation
} = wafApi;
